export interface SelectItem {
  id: string | number;
  label: string;
}

export const LIST_TYPE_COPIE: Array<SelectItem> = [
  <SelectItem>{'id': 'STD', 'label': 'Standard'},
  <SelectItem>{'id': 'CIRC', 'label': 'Circulation'},
  <SelectItem>{'id': 'NO_F', 'label': 'Non facturé'},
  <SelectItem>{'id': 'APAR', 'label': 'Demande à part'},
];


export const LIST_STATUS: Array<SelectItem> = [
  <SelectItem>{'id': 6, 'label': 'OK'},
  <SelectItem>{'id': 5, 'label': '4'},
  <SelectItem>{'id': 4, 'label': '3'},
  <SelectItem>{'id': 3, 'label': '2'},
  <SelectItem>{'id': 2, 'label': '1'},
  <SelectItem>{'id': 1, 'label': 'NON'},
];

export const LIST_TYPE_CONTRACT: Array<SelectItem> = [
  <SelectItem>{'id': 1, 'label': 'Commercial'},
  <SelectItem>{'id': 2, 'label': 'Prết'},
  <SelectItem>{'id': 3, 'label': 'Forfait'},
];

export const LIST_TYPE_FACTURE: Array<SelectItem> = [
  <SelectItem>{'id': "cine", 'label': 'Cinéma'},
  <SelectItem>{'id': "societe_base", 'label': ' Une société de la base'},
  <SelectItem>{'id': "custom", 'label': 'Autre'},
];

export const LIST_TVA: Array<SelectItem> = [
  <SelectItem>{'id': 1, 'label': '0'},
  <SelectItem>{'id': 1.2, 'label': '20'},
];

export const TRANSPORT_STATUS = [
  <SelectItem>{'id': 1, 'label': 'En attente'},
  <SelectItem>{'id': 2, 'label': 'En cours'},
  <SelectItem>{'id': 3, 'label': 'Envoyé'},
  <SelectItem>{'id': 4, 'label': 'Livré'},
  <SelectItem>{'id': 5, 'label': 'Annulé'}
];


export const COMMERCIAL = 1;
export const LOAN = 2;
export const FORFAIT = 3;

export const CINEGO = 50;
export const GC = 2556;
export const GC_ABONNEES = 2560;

export const GLOBECAST_ABONNES = 2560;

export const NOTRANSPORT = 0;
export const REQ_DUPLIC_SEND = 1;
export const REQ_DIGITAL_SEND = 3;
export const REQ_DISTRIB = 4;
export const REQ_ORGANISE = 5;


export const CREATED = 0;
export const WAITING = 1;
export const RECEIVED_PROVIDER = 2;
export const SENT = 3;
export const RECEIVED_SITE = 4;
export const CANCELED = 5;

export const GPCI = 5678;
export const ADRC = 'ADRC'
